import React from 'react';
import Footer from './Footer';
import Contact from './ContactParts';
import PageTop from './PageTop';
import SlideIn from './SlideIn';
import CleanUrls from './CleanUrls';

export default function Layout({ children, elementType = 'section', contentId = 'subpage' }) {
  const Element = elementType;

  return (
    <>
      <PageTop />
      <SlideIn />
      <CleanUrls />
      <main role="main" id="page">
        <Element id={contentId}>
          <div className={`main-content`}>{children}</div>
        </Element>
      </main>
      <Contact />
      <Footer />
    </>
  );
}
